import { SpinnerService } from './services/spinner.service';
import { PreLoaderService } from './services/pre-loader.service';
import { LoadingService } from 'libs/shared/src/lib/service/loading.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './guard/auth.guard';
import { LogoutGuard } from './guard/logout.guard';
import { AccessRightsService } from 'libs/shared/src/lib/service/access-rights.service';
import { MenuService } from 'libs/base/src/lib/services/menu.service'
import { UnsaveChangesGuard } from './guard/unsave-changes.guard';
import { InstallerAuthGuard } from './guard/installer-auth.guard';

@NgModule({
  imports: [CommonModule],
  providers: [LoadingService,LogoutGuard, PreLoaderService, SpinnerService, AccessRightsService, MenuService, UnsaveChangesGuard, InstallerAuthGuard]
})
export class BaseModule {
}
